<template>
      <div class="flex justify-center gap-5 rdc-plan__container">
            <div class="plan h-fit">
                  <img
                        src="../assets/RezDeChaussee/gite_le_cormier_rdc_plan.png"
                        alt=""
                  />

                  <div>
                        <!-- Chambre au rez de chaussee #chambre-rez-de-chaussee-->
                        <router-link
                              to="/descriptifs/gallerie/rez-de-chaussee/chambre"
                              active-class="active"
                              v-on:mouseenter="afficheChambreRdcItems"
                              v-on:mouseleave="supprimeChambreRdcItemsStyle"
                        >
                              <div class="chambre_plan_button">
                                    <img
                                          src="../assets/RezDeChaussee/rdc_chambre_plan_1.jpg"
                                          class="plan__rdc-chambre_1"
                                    />

                                    <img
                                          src="../assets/RezDeChaussee/rdc_chambre_plan_2.jpg"
                                          class="plan__rdc-chambre_2"
                                    />
                              </div>
                        </router-link>

                        <!--- La salle de bain --->
                        <router-link
                              to="/descriptifs/gallerie/rez-de-chaussee/salle-de-bain"
                              class="plan__rdc-sdb"
                              active-class="active"
                              v-on:mouseenter="afficheSdbRdcItems"
                              v-on:mouseleave="supprimeSdbRdcItemsStyle"
                        >
                              <img
                                    src="../assets/RezDeChaussee/rdc_sdb_plan.jpg"
                                    alt=""
                              />
                        </router-link>

                        <!--- La cuisine --->
                        <router-link
                              to="/descriptifs/gallerie/rez-de-chaussee/cuisine"
                              active-class="active"
                              v-on:mouseenter="afficheCuisineItems"
                              v-on:mouseleave="supprimeCuisineItemsStyle"
                        >
                              <div class="cuisine_plan_button">
                                    <img
                                          src="../assets/RezDeChaussee/rdc_cuisine_plan_1.jpg"
                                          alt=""
                                          class="plan__rdc-cuisine_1"
                                    />

                                    <img
                                          src="../assets/RezDeChaussee/rdc_cuisine_plan_2.jpg"
                                          alt=""
                                          class="plan__rdc-cuisine_2"
                                    />
                              </div>
                        </router-link>

                        <!--- Le salon --->
                        <router-link
                              to="/descriptifs/gallerie/rez-de-chaussee/salon"
                              class="plan__rdc-salon"
                              active-class="active"
                              v-on:mouseenter="afficheSalonItems"
                              v-on:mouseleave="supprimeSalonItemsStyle"
                        >
                              <img
                                    src="../assets/RezDeChaussee/rdc_salon_plan.jpg"
                                    alt=""
                              />
                        </router-link>

                        <!--- La salle à manger --->
                        <!-- pc --->
                        <router-link
                              to="/descriptifs/gallerie/rez-de-chaussee/salle-a-manger"
                              class="plan__rdc-sejour pc"
                              active-class="active"
                              v-on:mouseenter="afficheSalleAMangerItems"
                              v-on:mouseleave="supprimeSalleAMangerItemsStyle"
                        >
                              <img
                                    src="../assets/RezDeChaussee/rdc_sejour_plan.jpg"
                                    alt=""
                              />
                        </router-link>
                  </div>
            </div>

            <div class="bg-white px-4 rounded-lg text-start">
                  <h1 class="font-semibold">Au rez-de-chaussée :</h1>

                  <ul>
                        <li
                              v-for="description in rdcDescription"
                              :key="description.id"
                              v-bind:id="description.class"
                              :class="{
                                    applyActive: $route.path.includes(
                                          description.route
                                    ),
                              }"
                        >
                              {{ description.details }}
                        </li>
                  </ul>
            </div>
      </div>
</template>

<script setup>
const rdcDescription = [
      {
            id: 1,
            details: "Salon",
            englishDetails: "Living room",
            class: "rdc_salon",
            route: "salon",
      },

      {
            id: 2,
            details: "Salle à manger",
            englishDetails: "Dining room",
            class: "rdc_sam",
            route: "salle-a-manger",
      },

      {
            id: 3,
            details: "Cuisine",
            englishDetails: "Kitchen",
            class: "rdc_cuisine",
            route: "cuisine",
      },

      {
            id: 4,
            details: "Buanderie",
            englishDetails: "Laundry room",
            class: "rdc_buanderie",
      },

      {
            id: 5,
            details: "1 chambre (1 lit 2 personnes)",
            englishDetails: "1 bedroom (1 double bed)",
            class: "rdc_chambre",
            route: "chambre",
      },

      {
            id: 6,
            details: "Salle d'eau",
            englishDetails: "Bathroom",
            class: "rdc_salledeau",
            route: "salle-de-bain",
      },

      {
            id: 7,
            details: "WC",
            englishDetails: "Toilet",
            class: "rdc_wc",
      },
];

// La chambre du rez de chausse
const afficheChambreRdcItems = () => {
      const chambre = document.getElementById("rdc_chambre");

      if (!chambre.classList.contains("applyActive")) {
            chambre.classList.add("applyRouteActive");
      }
};

const supprimeChambreRdcItemsStyle = () => {
      const chambre = document.getElementById("rdc_chambre");

      if (!chambre.classList.contains("applyActive")) {
            chambre.classList.remove("applyRouteActive");
      }
};

// La salle de bain du rez de chausse
const afficheSdbRdcItems = () => {
      const salleDeau = document.getElementById("rdc_salledeau");

      if (!salleDeau.classList.contains("applyActive")) {
            salleDeau.classList.add("applyRouteActive");
      }
};

const supprimeSdbRdcItemsStyle = () => {
      const salleDeau = document.getElementById("rdc_salledeau");

      if (!salleDeau.classList.contains("applyActive")) {
            salleDeau.classList.remove("applyRouteActive");
      }
};

// Cuisine
const afficheCuisineItems = () => {
      const cuisine = document.getElementById("rdc_cuisine");

      if (!cuisine.classList.contains("applyActive")) {
            cuisine.classList.add("applyRouteActive");
      }
};

const supprimeCuisineItemsStyle = () => {
      const cuisine = document.getElementById("rdc_cuisine");

      if (!cuisine.classList.contains("applyActive")) {
            cuisine.classList.remove("applyRouteActive");
      }
};

// Salon
const afficheSalonItems = () => {
      const salon = document.getElementById("rdc_salon");

      if (!salon.classList.contains("applyActive")) {
            salon.classList.add("applyRouteActive");
      }
};

const supprimeSalonItemsStyle = () => {
      const salon = document.getElementById("rdc_salon");

      if (!salon.classList.contains("applyActive")) {
            salon.classList.remove("applyRouteActive");
      }
};

// Salle a manger
const afficheSalleAMangerItems = () => {
      const sam = document.getElementById("rdc_sam");

      if (!sam.classList.contains("applyActive")) {
            sam.classList.add("applyRouteActive");
      }
};

const supprimeSalleAMangerItemsStyle = () => {
      const sam = document.getElementById("rdc_sam");

      if (!sam.classList.contains("applyActive")) {
            sam.classList.remove("applyRouteActive");
      }
};
</script>

<style scoped lang="scss">
.rdc-plan__container {
      width: 60%;
      margin: auto;

      @media screen and (max-width: 769px) {
            display: flex;
            flex-direction: column-reverse;
            width: 85%;
      }
}

.applyActive {
      transition: 0.2s ease-in-out;
      margin-left: -0.1em;
      background: #08a045;
      border-radius: 0.5em;
      color: #fff;
      padding: 0 0.2em;
}

.applyRouteActive {
      transition: 0.2s ease-in-out;
      margin-left: -0.1em;
      color: #08a045;
      border-radius: 0.5em;
      font-weight: 700;
      padding: 0 0.2em;
}

.plan {
      position: relative;
      width: 60%;
      //margin: auto;

      @media screen and (max-width: 769px) {
            width: 100%;
      }

      @media screen and (max-width: 550px) {
            //display: none;
            //width: 20%;
      }

      // Rez de chaussee
      &__rdc-chambre_1 {
            position: absolute;
            width: 18%;
            top: 25%;
            left: 1%;
      }

      &__rdc-chambre_2 {
            position: absolute;
            width: 23%;
            bottom: 1%;
            left: 1%;
      }

      .active {
            opacity: 0.5;
      }

      .active .chambre_plan_button {
            opacity: 0.8;
      }

      .chambre_plan_button {
            opacity: 0;

            &:hover {
                  transition: 0.5s ease-in;
                  opacity: 0.4;
            }

            @media screen and (max-width: 769px) {
                  opacity: 0.1;
            }

            @media screen and (max-width: 550px) {
                  opacity: 0.1;
            }
      }

      &__rdc-sdb {
            position: absolute;
            width: 19%;
            top: 25%;
            left: 19%;
            opacity: 0;

            &:hover {
                  transition: 0.5s ease-in;
                  opacity: 0.4;
            }

            @media screen and (max-width: 769px) {
                  opacity: 0.1;
            }

            @media screen and (max-width: 550px) {
                  opacity: 0.1;
            }
      }

      .active .cuisine_plan_button {
            opacity: 0.8;
      }

      .cuisine_plan_button {
            opacity: 0;

            &:hover {
                  transition: 0.5s ease-in;
                  opacity: 0.5;
            }

            @media screen and (max-width: 769px) {
                  opacity: 0.1;
            }

            @media screen and (max-width: 550px) {
                  opacity: 0.1;
            }
      }

      &__rdc-cuisine_1 {
            position: absolute;
            width: 10%;
            top: 25%;
            left: 38%;
      }

      &__rdc-cuisine_2 {
            position: absolute;
            width: 24%;
            bottom: 1%;
            left: 24%;
      }

      &__rdc-salon {
            position: absolute;
            width: 26%;
            top: 25%;
            right: 26%;
            opacity: 0;

            &:hover {
                  transition: 0.5s ease-in;
                  opacity: 0.4;
            }

            @media screen and (max-width: 769px) {
                  opacity: 0.1;
            }

            @media screen and (max-width: 550px) {
                  opacity: 0.1;
            }
      }

      &__rdc-sejour {
            position: absolute;
            width: 25%;
            top: 25%;
            right: 0.8%;
            opacity: 0;

            &:hover {
                  transition: 0.5s ease-in;
                  opacity: 0.4;
            }

            @media screen and (max-width: 769px) {
                  opacity: 0.1;
            }

            @media screen and (max-width: 550px) {
                  opacity: 0.1;
            }
      }
}
</style>